(function () {
	"use strict";

	function checkSavedCourses() {
		const savedCoursesRaw = localStorage.getItem('flinders_saved_courses');
		
		if (savedCoursesRaw) {
			try {
				const savedCourses = JSON.parse(savedCoursesRaw);
				
				// Handle both array and object data structures
				const paths = Array.isArray(savedCourses) ? savedCourses : (savedCourses.paths || []);
				const hasSavedCourses = paths.length > 0;
				
				const heartIcons = document.querySelectorAll('.heart-icon');
				const heartDotIcons = document.querySelectorAll('.heart-dot-icon');
				
				heartIcons.forEach(icon => {
					icon.style.display = hasSavedCourses ? 'none' : 'inline-block';
				});
				
				heartDotIcons.forEach(icon => {
					icon.style.display = hasSavedCourses ? 'inline-block' : 'none';
				});
			} catch (e) {
				console.error('Error parsing saved courses from localStorage:', e);
			}
		}
	}

	function openSearchModal() {
		const searchModal = document.getElementById('search-modal');
		
		if (searchModal) {
			searchModal.style.display = 'flex';
			searchModal.classList.add('search-modal-open');
		} else {
			console.error('search-modal element not found');
		}
		
		document.getElementById('search-modal-backdrop').style.display = 'block';
		document.body.classList.add('no-scroll');
	}

	function closeSearchModal() {
		const searchModal = document.getElementById('search-modal');
		
		if (searchModal) {
			searchModal.style.display = 'none';
			searchModal.classList.remove('search-modal-open');
		} else {
			console.error('search-modal element not found');
		}
		
		document.getElementById('search-modal-backdrop').style.display = 'none';
		document.body.classList.remove('no-scroll');
	}

	function initStickyHeader() {
		const header = document.querySelector('.cmp-flindersonline-header');
		if (!header) return;

		// Check if parent element has header_style_transparent class
		const hasTransparentStyle = header.closest('.header_style_transparent') !== null;
		
		if (hasTransparentStyle) {
			header.classList.add('header-transparent');
		}

		// Create a placeholder to prevent content jump when header becomes fixed
		const headerPlaceholder = document.createElement('div');
		headerPlaceholder.classList.add('header-placeholder');
		header.parentNode.insertBefore(headerPlaceholder, header.nextSibling);

		ScrollTrigger.create({
			trigger: "body",
			start: "0px top",
			end: "bottom bottom",
			onEnter: () => {
				// Activate sticky header
				headerPlaceholder.style.height = '73px';
				header.classList.add('sticky-header');
				
				// Add opaque background if transparent style is enabled
				if (hasTransparentStyle) {
					header.classList.add('header-opaque');
				}
			},
			onLeave: () => {
				// Keep sticky when scrolling past the end
			},
			onEnterBack: () => {
				// Keep sticky when coming back up
			},
			onLeaveBack: () => {
				// Deactivate sticky header
				header.classList.remove('sticky-header');
				headerPlaceholder.style.height = '0px';
				
				// Remove opaque background if transparent style is enabled
				if (hasTransparentStyle) {
					header.classList.remove('header-opaque');
				}
			}
		});
	}

	function initHeaderComponent() {
		const headerComponents = document.querySelectorAll('.cmp-flindersonline-header');
		if (headerComponents.length === 0) {
			console.warn('No header components found');
			return;
		}
		headerComponents.forEach(headerComponent => {
			checkSavedCourses();
		});

		// Initialize sticky header functionality
		initStickyHeader();
		monitorSavedCoursesChange('flinders_saved_courses', checkSavedCourses);

		// Search button event
		const searchBtns = document.querySelectorAll('.header-btn.search-btn');
		searchBtns.forEach((btn, index) => {
			btn.addEventListener('click', function(e) {
				openSearchModal();
			});
		});
		
		// Close button event
		const closeBtn = document.getElementById('search-modal-close');
		if (closeBtn) {
			closeBtn.addEventListener('click', function(e) {
				closeSearchModal();
			});
		}
		
		// Backdrop event
		const backdrop = document.getElementById('search-modal-backdrop');
		if (backdrop) {
			backdrop.addEventListener('click', function(e) {
				closeSearchModal();
			});
		}

		// Search input event
		const searchInput = document.querySelector('.search-modal__input');
		const header = document.querySelector('.cmp-flindersonline-header');
		if (searchInput && header) {
			searchInput.addEventListener('keydown', function(e) {
				if (e.key === 'Enter') {
					e.preventDefault();
					const query = searchInput.value.trim();
					if (!query) return;
					const pagePathRaw = header.getAttribute('data-search-result-page-path') || '/search.html';
					let pagePath = pagePathRaw;
					if (!pagePath.endsWith('.html')) {
						pagePath += '.html';
					}
					let syntax = header.getAttribute('data-search-result-page-path-syntax') || '';
					let url;
					if (syntax && syntax.includes('{searchTerm}')) {
						url = pagePath + syntax.replace('{searchTerm}', encodeURIComponent(query));
					} else if (syntax && syntax.includes('=')) {
						url = pagePath + syntax + encodeURIComponent(query);
					} else {
						url = pagePath + '?q=' + encodeURIComponent(query);
					}
					window.location.href = url;
				}
				if (e.key === 'Escape') {
					closeSearchModal();
				}
			});
		}

		// Also allow Escape to close modal when focus is not in input
		document.addEventListener('keydown', function(e) {
			const modal = document.getElementById('search-modal');
			if (e.key === 'Escape' && modal && modal.style.display === 'flex') {
				closeSearchModal();
			}
		});
	}

	
	window.addEventListener('load', function () {
		initHeaderComponent();
	});
})();